import {Types} from "@Common/types";

const today = new Date;

export const getLastMonthName = () => (
    new Date(today.getFullYear(), today.getMonth() - 1).toLocaleDateString("en-US", {month: "long"})
);

export const getLastYear = () => (
    today.getFullYear() - 1
);

export const makeEmptyResultRows = ({titles}:{titles: string[]}): Types.Xpresso.Account.Admin.Reporting.ActivityDashboard.ReportModuleTabResultRow[] => (
    titles.map(title => ({title, content: "Not Available"}))
);

